import { GET } from ".";
export const documentsRegister = {
  getDocumentsRegister: () => GET(`/api/documentsRegister/`)
};
